<template>
  <div
    class="progress-line"
    :class="{ 'progress-line--glow': glow, 'progress-line--indeterminate': indeterminate }"
    :style="{ height: `${height}px`, width }"
    role="progressbar"
    :aria-valuemin="indeterminate ? undefined : 0"
    :aria-valuemax="indeterminate ? undefined : 100"
    :aria-valuenow="indeterminate ? undefined : Math.round(clamped * 100)"
  >
    <span class="progress-line__fill" :style="indeterminate ? undefined : { width: `${clamped * 100}%` }"></span>
  </div>
</template>

<script setup>
/**
 * ProgressLine — тонкая лаймовая линия прогресса (под заголовком экранов 4 и 7).
 *
 * <ProgressLine :value="0.35" />            // 35%
 * <ProgressLine indeterminate />            // бегущий сегмент
 * <ProgressLine :value="p" :height="8" width="100%" />
 *
 * props: value (0..1), indeterminate, height (px, 4), width (CSS, '100%'), glow (true).
 */
import { computed } from "vue";

const props = defineProps({
  value: { type: Number, default: 0 },
  indeterminate: { type: Boolean, default: false },
  height: { type: Number, default: 4 },
  width: { type: String, default: "100%" },
  glow: { type: Boolean, default: true },
});

const clamped = computed(() => Math.min(1, Math.max(0, Number(props.value) || 0)));
</script>

<style scoped>
.progress-line {
  position: relative;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.09);
}

.progress-line__fill {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: inherit;
  background: var(--cb-lime);
  transition: width 0.4s var(--cb-ease);
}

.progress-line--glow {
  overflow: visible;
}

.progress-line--glow .progress-line__fill {
  box-shadow: 0 0 10px rgba(221, 245, 90, 0.6);
}

.progress-line--indeterminate {
  overflow: hidden;
}

.progress-line--indeterminate .progress-line__fill {
  width: 40%;
  animation: cb-indeterminate 1.4s var(--cb-ease) infinite;
}
</style>
